export default {
	"order.paymentSuccessful": "支付成功",
	"order.ParameterError": "参数错误",
	"order.YourPaymentResultHasNotBeenQueriedYet": "暂未查询到您的支付结果",
	"order.lookUpAgain": "重新查询",
	"order.payAgain": "重新支付",
	"order.RequestingPaymentResults": "请求支付结果中..."
}